"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyLoans = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var get_loans_1 = require("../api/loan/get_loans");
var content_dialog_1 = require("../features/thunks/content-dialog");
var useCurrency_1 = require("../hooks/useCurrency");
var store_1 = require("../store");
var loan_application_1 = require("../types/loan-application");
var currency_1 = require("../utils/currency");
var MyLoans = function (_a) {
    var branding = _a.branding, siteName = _a.siteName, siteConfig = _a.siteConfig, onViewLoan = _a.onViewLoan, onClose = _a.onClose;
    var dispatch = (0, store_1.useAppDispatch)();
    var currency = (0, useCurrency_1.useCurrency)(siteConfig).currency;
    var _b = (0, react_1.useState)("all"), activeTab = _b[0], setActiveTab = _b[1];
    var _c = (0, react_1.useState)([]), loans = _c[0], setLoans = _c[1];
    var _d = (0, react_1.useState)(true), loansLoading = _d[0], setLoansLoading = _d[1];
    var _e = (0, react_1.useState)(null), loansError = _e[0], setLoansError = _e[1];
    // Fetch user loans using Firebase directly
    (0, react_1.useEffect)(function () {
        var fetchLoans = function () { return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoansLoading(true);
                        setLoansError(null);
                        return [4 /*yield*/, (0, get_loans_1.getUserLoans)()];
                    case 1:
                        result = _a.sent();
                        if (result.success && result.content) {
                            setLoans(result.content);
                        }
                        else {
                            setLoansError(result.message || "Failed to load loans");
                        }
                        setLoansLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchLoans();
    }, []);
    var formatDate = function (dateValue) {
        if (!dateValue)
            return "N/A";
        try {
            var date = void 0;
            // Handle Firestore Timestamp (object with seconds property)
            if (typeof dateValue === "object" && "seconds" in dateValue) {
                date = new Date(dateValue.seconds * 1000);
            }
            else if (typeof dateValue === "string") {
                date = new Date(dateValue);
            }
            else if (dateValue instanceof Date) {
                date = dateValue;
            }
            else {
                return "N/A";
            }
            // Check if date is valid
            if (isNaN(date.getTime())) {
                return "N/A";
            }
            return date.toLocaleDateString("en-ZA", {
                year: "numeric",
                month: "short",
                day: "numeric",
            });
        }
        catch (error) {
            return "N/A";
        }
    };
    var formatCurrency = function (amount) {
        return (0, currency_1.formatCurrencyDisplay)(amount, currency);
    };
    var getStatusColor = function (status) {
        switch (status.toUpperCase()) {
            case "APPROVED":
            case "ACTIVE":
                return "text-green-600";
            case "PAID":
                return "text-blue-600";
            case "AWAIT":
                return "text-yellow-600";
            case "DECLINED":
                return "text-red-600";
            case "DRAFT":
                return "text-gray-600";
            default:
                return "text-gray-600";
        }
    };
    var getStatusText = function (status) {
        switch (status.toUpperCase()) {
            case "APPROVED":
                return "Active";
            case "AWAIT":
                return "Pending";
            default:
                return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
        }
    };
    var filterLoans = function (loans, status) {
        if (status === "all")
            return loans;
        return loans.filter(function (loan) {
            var loanStatus = loan.status.toUpperCase();
            switch (status) {
                case "active":
                    return ["ACTIVE", "APPROVED"].includes(loanStatus);
                case "paid":
                    return loanStatus === "PAID";
                default:
                    return true;
            }
        });
    };
    var filteredLoans = filterLoans(loans, activeTab);
    var handleViewLoan = function (loan) {
        if (onViewLoan) {
            onViewLoan(loan);
        }
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "w-full h-full max-h-[90vh] overflow-y-auto rounded-lg shadow-xl", style: { backgroundColor: "#F4F6F8" }, children: [(0, jsx_runtime_1.jsx)("div", { className: "flex items-center p-6 border-b border-gray-200", style: { backgroundColor: "#F4F6F8" }, children: (0, jsx_runtime_1.jsx)("h1", { className: "text-2xl font-bold text-gray-900", children: "My Loans" }) }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col p-6 space-y-8", children: (0, jsx_runtime_1.jsxs)("div", { className: "w-full p-6 flex flex-col bg-white rounded-2xl shadow-sm", style: { boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)" }, children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-xl font-semibold text-gray-900 mb-6", children: "Loan History" }), (0, jsx_runtime_1.jsx)("div", { className: "flex space-x-1 bg-gray-100 p-1 rounded-lg mb-6", children: [
                                    { key: "all", label: "All Loans" },
                                    { key: "active", label: "Active" },
                                    { key: "paid", label: "Paid Off" },
                                ].map(function (tab) { return ((0, jsx_runtime_1.jsx)("button", { onClick: function () { return setActiveTab(tab.key); }, className: "flex-1 py-2 px-3 text-sm font-medium rounded-md transition-colors ".concat(activeTab === tab.key
                                        ? "text-white shadow-sm"
                                        : "text-gray-500 hover:text-gray-700"), style: activeTab === tab.key
                                        ? { backgroundColor: branding.primaryColor }
                                        : {}, children: tab.label }, tab.key)); }) }), (0, jsx_runtime_1.jsx)("div", { className: "overflow-y-auto max-h-96", children: loansLoading ? ((0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-center h-32", children: (0, jsx_runtime_1.jsx)("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2", style: { borderColor: branding.primaryColor } }) })) : loansError ? ((0, jsx_runtime_1.jsx)("div", { className: "text-center py-8 text-gray-500", children: (0, jsx_runtime_1.jsx)("p", { children: loansError }) })) : filteredLoans.length === 0 ? ((0, jsx_runtime_1.jsx)("div", { className: "text-center py-8 text-gray-500", children: (0, jsx_runtime_1.jsx)("p", { children: "No loans found in this category" }) })) : ((0, jsx_runtime_1.jsxs)("div", { className: "bg-white rounded-lg overflow-hidden shadow-sm", children: [(0, jsx_runtime_1.jsx)("div", { className: "bg-gray-50 px-6 py-3 border-b border-gray-200", children: (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-5 gap-4 font-semibold text-gray-700", children: [(0, jsx_runtime_1.jsx)("div", { children: "ID" }), (0, jsx_runtime_1.jsx)("div", { children: "Date" }), (0, jsx_runtime_1.jsx)("div", { children: "Amount" }), (0, jsx_runtime_1.jsx)("div", { children: "Status" }), (0, jsx_runtime_1.jsx)("div", { children: "Actions" })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "divide-y divide-gray-200", children: filteredLoans.map(function (loan, index) { return ((0, jsx_runtime_1.jsx)("div", { className: "px-6 py-4 hover:bg-gray-50 transition-colors", children: (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-5 gap-4 items-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "font-medium text-gray-900", children: loan.status === "APPROVED"
                                                                ? loan.loan_number || loan.code
                                                                : loan.code }), (0, jsx_runtime_1.jsx)("div", { className: "text-gray-600", children: formatDate(loan.date_started) }), (0, jsx_runtime_1.jsx)("div", { className: "font-semibold text-gray-900", children: formatCurrency(loan.amount) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { className: "inline-flex px-2 py-1 text-xs font-medium rounded-full bg-gray-100 ".concat(getStatusColor(loan.status)), children: getStatusText(loan.status) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex gap-3", children: [(0, jsx_runtime_1.jsx)("button", { onClick: function () { return handleViewLoan(loan); }, className: "text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors", children: "View" }), (loan === null || loan === void 0 ? void 0 : loan.status) === loan_application_1.APPLICATION_STATUS.DRAFT && ((0, jsx_runtime_1.jsx)("button", { onClick: function () {
                                                                        dispatch((0, content_dialog_1.closeContentDialogThunk)());
                                                                        window.dispatchEvent(new CustomEvent("openLoanApplication", {
                                                                            detail: __assign({}, loan),
                                                                        }));
                                                                    }, className: "text-red-600 hover:text-red-800 text-sm font-medium transition-colors", children: "Edit" }))] })] }) }, loan.uid || index)); }) })] })) })] }) })] }) }));
};
exports.MyLoans = MyLoans;
